(function() {
  const cartWrapperSelector = '.ajax-cartWrap';
  const addToCartButtonSelector = '.ajax-addToCart';
  const cartItemQuantitySelector = '.ajax-cartQuantity';
  const buttonLoadingClassName = 'loading';
  const buttonAddedClassName = 'added';

  document.addEventListener('click', handleAddToCartClick);

  function handleAddToCartClick(event) {
    const addToCartButton = findAddToCartButton(event.target);
    if (!addToCartButton) return;

    const selectedVariantId = Number(addToCartButton.dataset.variantId);
    if (Number.isNaN(selectedVariantId)) return;
    
    const buttonAnimation = createButtonAnimation(addToCartButton);
    buttonAnimation.start();
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] })
    })
      .then(() => {
        buttonAnimation.completed();
        refreshCartItemQuantity();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(buttonAnimation.finish);
  }

  function refreshCartItemQuantity() {
    fetch(window.Shopify.routes.root + 'cart.json')
      .then(response => response.json())
      .then(({ item_count: cartItemCount }) => {
        updateCartItemQuantityOnUi(cartItemCount);
      });
  }

  function updateCartItemQuantityOnUi(cartItemCount) {
    document.querySelectorAll(cartItemQuantitySelector).forEach(element => {
      element.innerHTML = cartItemCount;
    });
    document.querySelectorAll(cartWrapperSelector).forEach(cartElement => {
      if (cartItemCount > 0) {
        cartElement.classList.add('green');
      } else {
        cartElement.classList.remove('green');
      }
    });
  }

  function findAddToCartButton(targetElement) {
    return targetElement.closest(addToCartButtonSelector);
  }

  function createButtonAnimation(buttonElement) {
    return {
      start() {
        buttonElement.disabled = false;
        buttonElement.classList.add(buttonLoadingClassName);
      },
      completed() {
        buttonElement.classList.remove(buttonLoadingClassName);
        buttonElement.classList.add(buttonAddedClassName);
        setTimeout(() => buttonElement.classList.remove(buttonAddedClassName), 1000);
      },
      finish() {
        buttonElement.disabled = false;
        buttonElement.classList.remove(buttonLoadingClassName);
      }
    };
  }
})();
